<template>
  <div class="research_6">
    <v-container>
      <v-row class="mt-4" justify="center">
        <v-col cols="10" xl="8">
          <div class="heading text-h6 text-sm-h4 font-weight-bold pl-4">
            共感的応答を導くメタプロンプト最適化型マルチモーダルAI
          </div>
        </v-col>
        <v-col cols="9" xl="7">
          <div>
            <div>助成：科学研究費補助金 基盤研究(C)（2026〜2028年度）</div>
          </div>
        </v-col>
      </v-row>

      <v-row class="my-4" justify="center">
        <v-col cols="9" lg="8" xl="5">
          <a>
            <v-img @click="clickImage(require(`@/assets/research/R6_research.png`))"
            :src="require(`@/assets/research/R6_research.png`)"></v-img>
          </a>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "R6",
  methods: {
    clickImage: function (image) {
      window.open(image);
    }
  }
}
</script>
<style scoped>
.heading {
  border-bottom: 2px solid #000;
}
</style>
